import { Stack } from "react-bootstrap";
import { Term } from "../../utils/interfaces";
import ListSorter from "../ListSorter/ListSorter"

type Step2Props = {
  onToggle: (item: Term) => void;
  label: string;
  topCategory: string | undefined;
  topList: Array<Term>;
};

const Step2: React.FC<Step2Props> = ({
  topList,
  label,
  topCategory,
  onToggle,
}) => {
  const selectedList = topList.filter(item => item.selected)

  return (
    <Stack gap={3}>
      <h3>
        Select your top 10 {label} from the "{topCategory}" pile ({selectedList.length}/10)
      </h3>
      <div>
        <ListSorter items={topList} onToggle={onToggle} maxItems={10} />
      </div>
    </Stack>
  );
};

export default Step2;
